export const checkoutSessionExample = {
  id: "test_session",
  name: "Mock Checkout Session",
  icon: "stripe",
  payload: {
    id: "cs_test_a1LFuyKHsmzBxr6SvxfFu184ISK2sNebnb60DloYuCenBcJtfGttTydm4n",
    object: "checkout.session",
    after_expiration: null,
    allow_promotion_codes: null,
    amount_subtotal: 3000,
    amount_total: 3000,
    automatic_tax: {
      enabled: false,
      status: null,
    },
    billing_address_collection: null,
    cancel_url: "https://httpbin.org/post",
    client_reference_id: null,
    consent: null,
    consent_collection: null,
    created: 1690472483,
    currency: "usd",
    currency_conversion: null,
    custom_fields: [],
    custom_text: {
      shipping_address: null,
      submit: null,
    },
    customer: null,
    customer_creation: "if_required",
    customer_details: {
      address: {
        city: "South San Francisco",
        country: "US",
        line1: "354 Oyster Point Blvd",
        line2: null,
        postal_code: "94080",
        state: "CA",
      },
      email: "stripe@example.com",
      name: "Jenny Rosen",
      phone: null,
      tax_exempt: "none",
      tax_ids: [],
    },
    customer_email: null,
    expires_at: 1690558883,
    invoice: null,
    invoice_creation: {
      enabled: false,
      invoice_data: {
        account_tax_ids: null,
        custom_fields: null,
        description: null,
        footer: null,
        metadata: {},
        rendering_options: null,
      },
    },
    livemode: false,
    locale: null,
    metadata: {},
    mode: "payment",
    payment_intent: "pi_3NYWJcI0XSgju2ur1bZTeRhR",
    payment_link: null,
    payment_method_collection: "always",
    payment_method_options: {},
    payment_method_types: ["card"],
    payment_status: "paid",
    phone_number_collection: {
      enabled: false,
    },
    recovered_from: null,
    setup_intent: null,
    shipping_address_collection: null,
    shipping_cost: null,
    shipping_details: null,
    shipping_options: [],
    status: "complete",
    submit_type: null,
    subscription: null,
    success_url: "https://httpbin.org/post",
    total_details: {
      amount_discount: 0,
      amount_shipping: 0,
      amount_tax: 0,
    },
    url: null,
  },
};

export const customerSubscriptionExample = {
  id: "test_subscription",
  name: "Mock Subscription",
  icon: "stripe",
  payload: {
    id: "sub_1NYWgUI0XSgju2urmVcglalG",
    object: "subscription",
    application: null,
    application_fee_percent: null,
    automatic_tax: {
      enabled: false,
    },
    billing_cycle_anchor: 1690473902,
    billing_thresholds: null,
    cancel_at: null,
    cancel_at_period_end: false,
    canceled_at: null,
    cancellation_details: {
      comment: null,
      feedback: null,
      reason: null,
    },
    collection_method: "charge_automatically",
    created: 1690473902,
    currency: "usd",
    current_period_end: 1693152302,
    current_period_start: 1690473902,
    customer: "cus_OLD6IR3D8CJasG",
    days_until_due: null,
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    ended_at: null,
    items: {
      object: "list",
      data: [
        {
          id: "si_OLD6qgIKdp0wZO",
          object: "subscription_item",
          billing_thresholds: null,
          created: 1690473903,
          metadata: {},
          plan: {
            id: "price_1NYWgUI0XSgju2ur3rwJGw1n",
            object: "plan",
            active: true,
            aggregate_usage: null,
            amount: 1500,
            amount_decimal: "1500",
            billing_scheme: "per_unit",
            created: 1690473902,
            currency: "usd",
            interval: "month",
            interval_count: 1,
            livemode: false,
            metadata: {},
            nickname: null,
            product: "prod_OLD6aEjleFDUfA",
            tiers_mode: null,
            transform_usage: null,
            trial_period_days: null,
            usage_type: "licensed",
          },
          price: {
            id: "price_1NYWgUI0XSgju2ur3rwJGw1n",
            object: "price",
            active: true,
            billing_scheme: "per_unit",
            created: 1690473902,
            currency: "usd",
            custom_unit_amount: null,
            livemode: false,
            lookup_key: null,
            metadata: {},
            nickname: null,
            product: "prod_OLD6aEjleFDUfA",
            recurring: {
              aggregate_usage: null,
              interval: "month",
              interval_count: 1,
              trial_period_days: null,
              usage_type: "licensed",
            },
            tax_behavior: "unspecified",
            tiers_mode: null,
            transform_quantity: null,
            type: "recurring",
            unit_amount: 1500,
            unit_amount_decimal: "1500",
          },
          quantity: 1,
          subscription: "sub_1NYWgUI0XSgju2urmVcglalG",
          tax_rates: [],
        },
      ],
      has_more: false,
      total_count: 1,
      url: "/v1/subscription_items?subscription=sub_1NYWgUI0XSgju2urmVcglalG",
    },
    latest_invoice: "in_1NYWgUI0XSgju2urV5ZTEyIn",
    livemode: false,
    metadata: {},
    next_pending_invoice_item_invoice: null,
    on_behalf_of: null,
    pause_collection: null,
    payment_settings: {
      payment_method_options: null,
      payment_method_types: null,
      save_default_payment_method: "off",
    },
    pending_invoice_item_interval: null,
    pending_setup_intent: null,
    pending_update: null,
    plan: {
      id: "price_1NYWgUI0XSgju2ur3rwJGw1n",
      object: "plan",
      active: true,
      aggregate_usage: null,
      amount: 1500,
      amount_decimal: "1500",
      billing_scheme: "per_unit",
      created: 1690473902,
      currency: "usd",
      interval: "month",
      interval_count: 1,
      livemode: false,
      metadata: {},
      nickname: null,
      product: "prod_OLD6aEjleFDUfA",
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: "licensed",
    },
    quantity: 1,
    schedule: null,
    start_date: 1690473902,
    status: "active",
    test_clock: null,
    transfer_data: null,
    trial_end: null,
    trial_settings: {
      end_behavior: {
        missing_payment_method: "create_invoice",
      },
    },
    trial_start: null,
  },
};

export const pausedSubscriptionExample = {
  id: "test_subscription",
  name: "Mock Subscription",
  icon: "stripe",
  payload: {
    id: "sub_1NYWgUI0XSgju2urmVcglalG",
    object: "subscription",
    application: null,
    application_fee_percent: null,
    automatic_tax: {
      enabled: false,
    },
    billing_cycle_anchor: 1690473902,
    billing_thresholds: null,
    cancel_at: null,
    cancel_at_period_end: false,
    canceled_at: null,
    cancellation_details: {
      comment: null,
      feedback: null,
      reason: null,
    },
    collection_method: "charge_automatically",
    created: 1690473902,
    currency: "usd",
    current_period_end: 1693152302,
    current_period_start: 1690473902,
    customer: "cus_OLD6IR3D8CJasG",
    days_until_due: null,
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    ended_at: null,
    items: {
      object: "list",
      data: [
        {
          id: "si_OLD6qgIKdp0wZO",
          object: "subscription_item",
          billing_thresholds: null,
          created: 1690473903,
          metadata: {},
          plan: {
            id: "price_1NYWgUI0XSgju2ur3rwJGw1n",
            object: "plan",
            active: true,
            aggregate_usage: null,
            amount: 1500,
            amount_decimal: "1500",
            billing_scheme: "per_unit",
            created: 1690473902,
            currency: "usd",
            interval: "month",
            interval_count: 1,
            livemode: false,
            metadata: {},
            nickname: null,
            product: "prod_OLD6aEjleFDUfA",
            tiers_mode: null,
            transform_usage: null,
            trial_period_days: null,
            usage_type: "licensed",
          },
          price: {
            id: "price_1NYWgUI0XSgju2ur3rwJGw1n",
            object: "price",
            active: true,
            billing_scheme: "per_unit",
            created: 1690473902,
            currency: "usd",
            custom_unit_amount: null,
            livemode: false,
            lookup_key: null,
            metadata: {},
            nickname: null,
            product: "prod_OLD6aEjleFDUfA",
            recurring: {
              aggregate_usage: null,
              interval: "month",
              interval_count: 1,
              trial_period_days: null,
              usage_type: "licensed",
            },
            tax_behavior: "unspecified",
            tiers_mode: null,
            transform_quantity: null,
            type: "recurring",
            unit_amount: 1500,
            unit_amount_decimal: "1500",
          },
          quantity: 1,
          subscription: "sub_1NYWgUI0XSgju2urmVcglalG",
          tax_rates: [],
        },
      ],
      has_more: false,
      total_count: 1,
      url: "/v1/subscription_items?subscription=sub_1NYWgUI0XSgju2urmVcglalG",
    },
    latest_invoice: "in_1NYWgUI0XSgju2urV5ZTEyIn",
    livemode: false,
    metadata: {},
    next_pending_invoice_item_invoice: null,
    on_behalf_of: null,
    pause_collection: null,
    payment_settings: {
      payment_method_options: null,
      payment_method_types: null,
      save_default_payment_method: "off",
    },
    pending_invoice_item_interval: null,
    pending_setup_intent: null,
    pending_update: null,
    plan: {
      id: "price_1NYWgUI0XSgju2ur3rwJGw1n",
      object: "plan",
      active: true,
      aggregate_usage: null,
      amount: 1500,
      amount_decimal: "1500",
      billing_scheme: "per_unit",
      created: 1690473902,
      currency: "usd",
      interval: "month",
      interval_count: 1,
      livemode: false,
      metadata: {},
      nickname: null,
      product: "prod_OLD6aEjleFDUfA",
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: "licensed",
    },
    quantity: 1,
    schedule: null,
    start_date: 1690473902,
    status: "paused",
    test_clock: null,
    transfer_data: null,
    trial_end: null,
    trial_settings: {
      end_behavior: {
        missing_payment_method: "create_invoice",
      },
    },
    trial_start: null,
  },
};

export const cancelledSubscriptionExample = {
  id: "test_subscription",
  name: "Cancelled Subscription",
  icon: "stripe",
  payload: {
    id: "sub_1NYWmqI0XSgju2urM6J7U81g",
    object: "subscription",
    application: null,
    application_fee_percent: null,
    automatic_tax: {
      enabled: false,
    },
    billing_cycle_anchor: 1690474295,
    billing_thresholds: null,
    cancel_at: null,
    cancel_at_period_end: false,
    canceled_at: 1690474298,
    cancellation_details: {
      comment: null,
      feedback: null,
      reason: "cancellation_requested",
    },
    collection_method: "charge_automatically",
    created: 1690474295,
    currency: "usd",
    current_period_end: 1693152695,
    current_period_start: 1690474295,
    customer: "cus_OLDDzu7ZE2wLZB",
    days_until_due: null,
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    ended_at: 1690474298,
    items: {
      object: "list",
      data: [
        {
          id: "si_OLDDWvHquPJrro",
          object: "subscription_item",
          billing_thresholds: null,
          created: 1690474296,
          metadata: {},
          plan: {
            id: "price_1NYWmpI0XSgju2ur8YboK1MK",
            object: "plan",
            active: true,
            aggregate_usage: null,
            amount: 1500,
            amount_decimal: "1500",
            billing_scheme: "per_unit",
            created: 1690474295,
            currency: "usd",
            interval: "month",
            interval_count: 1,
            livemode: false,
            metadata: {},
            nickname: null,
            product: "prod_OLDDFHiTTQUoPT",
            tiers_mode: null,
            transform_usage: null,
            trial_period_days: null,
            usage_type: "licensed",
          },
          price: {
            id: "price_1NYWmpI0XSgju2ur8YboK1MK",
            object: "price",
            active: true,
            billing_scheme: "per_unit",
            created: 1690474295,
            currency: "usd",
            custom_unit_amount: null,
            livemode: false,
            lookup_key: null,
            metadata: {},
            nickname: null,
            product: "prod_OLDDFHiTTQUoPT",
            recurring: {
              aggregate_usage: null,
              interval: "month",
              interval_count: 1,
              trial_period_days: null,
              usage_type: "licensed",
            },
            tax_behavior: "unspecified",
            tiers_mode: null,
            transform_quantity: null,
            type: "recurring",
            unit_amount: 1500,
            unit_amount_decimal: "1500",
          },
          quantity: 1,
          subscription: "sub_1NYWmqI0XSgju2urM6J7U81g",
          tax_rates: [],
        },
      ],
      has_more: false,
      total_count: 1,
      url: "/v1/subscription_items?subscription=sub_1NYWmqI0XSgju2urM6J7U81g",
    },
    latest_invoice: "in_1NYWmqI0XSgju2ur1YkCeiE3",
    livemode: false,
    metadata: {},
    next_pending_invoice_item_invoice: null,
    on_behalf_of: null,
    pause_collection: null,
    payment_settings: {
      payment_method_options: null,
      payment_method_types: null,
      save_default_payment_method: "off",
    },
    pending_invoice_item_interval: null,
    pending_setup_intent: null,
    pending_update: null,
    plan: {
      id: "price_1NYWmpI0XSgju2ur8YboK1MK",
      object: "plan",
      active: true,
      aggregate_usage: null,
      amount: 1500,
      amount_decimal: "1500",
      billing_scheme: "per_unit",
      created: 1690474295,
      currency: "usd",
      interval: "month",
      interval_count: 1,
      livemode: false,
      metadata: {},
      nickname: null,
      product: "prod_OLDDFHiTTQUoPT",
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: "licensed",
    },
    quantity: 1,
    schedule: null,
    start_date: 1690474295,
    status: "canceled",
    test_clock: null,
    transfer_data: null,
    trial_end: null,
    trial_settings: {
      end_behavior: {
        missing_payment_method: "create_invoice",
      },
    },
    trial_start: null,
  },
};

export const updatedSubscriptionExample = {
  id: "test_subscription",
  name: "Updated Subscription",
  icon: "stripe",
  payload: {
    id: "sub_1NYWr9I0XSgju2urREzIjypw",
    object: "subscription",
    application: null,
    application_fee_percent: null,
    automatic_tax: {
      enabled: false,
    },
    billing_cycle_anchor: 1690474563,
    billing_thresholds: null,
    cancel_at: null,
    cancel_at_period_end: false,
    canceled_at: null,
    cancellation_details: {
      comment: null,
      feedback: null,
      reason: null,
    },
    collection_method: "charge_automatically",
    created: 1690474563,
    currency: "usd",
    current_period_end: 1693152963,
    current_period_start: 1690474563,
    customer: "cus_OLDHaOoGMJKpbQ",
    days_until_due: null,
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    ended_at: null,
    items: {
      object: "list",
      data: [
        {
          id: "si_OLDHbwqQpcI7wJ",
          object: "subscription_item",
          billing_thresholds: null,
          created: 1690474564,
          metadata: {},
          plan: {
            id: "price_1NYWr9I0XSgju2urK88vlVrN",
            object: "plan",
            active: true,
            aggregate_usage: null,
            amount: 1500,
            amount_decimal: "1500",
            billing_scheme: "per_unit",
            created: 1690474563,
            currency: "usd",
            interval: "month",
            interval_count: 1,
            livemode: false,
            metadata: {},
            nickname: null,
            product: "prod_OLDHCaYW7Sp4Xg",
            tiers_mode: null,
            transform_usage: null,
            trial_period_days: null,
            usage_type: "licensed",
          },
          price: {
            id: "price_1NYWr9I0XSgju2urK88vlVrN",
            object: "price",
            active: true,
            billing_scheme: "per_unit",
            created: 1690474563,
            currency: "usd",
            custom_unit_amount: null,
            livemode: false,
            lookup_key: null,
            metadata: {},
            nickname: null,
            product: "prod_OLDHCaYW7Sp4Xg",
            recurring: {
              aggregate_usage: null,
              interval: "month",
              interval_count: 1,
              trial_period_days: null,
              usage_type: "licensed",
            },
            tax_behavior: "unspecified",
            tiers_mode: null,
            transform_quantity: null,
            type: "recurring",
            unit_amount: 1500,
            unit_amount_decimal: "1500",
          },
          quantity: 1,
          subscription: "sub_1NYWr9I0XSgju2urREzIjypw",
          tax_rates: [],
        },
      ],
      has_more: false,
      total_count: 1,
      url: "/v1/subscription_items?subscription=sub_1NYWr9I0XSgju2urREzIjypw",
    },
    latest_invoice: "in_1NYWr9I0XSgju2uro3uB0RuT",
    livemode: false,
    metadata: {
      foo: "bar",
    },
    next_pending_invoice_item_invoice: null,
    on_behalf_of: null,
    pause_collection: null,
    payment_settings: {
      payment_method_options: null,
      payment_method_types: null,
      save_default_payment_method: "off",
    },
    pending_invoice_item_interval: null,
    pending_setup_intent: null,
    pending_update: null,
    plan: {
      id: "price_1NYWr9I0XSgju2urK88vlVrN",
      object: "plan",
      active: true,
      aggregate_usage: null,
      amount: 1500,
      amount_decimal: "1500",
      billing_scheme: "per_unit",
      created: 1690474563,
      currency: "usd",
      interval: "month",
      interval_count: 1,
      livemode: false,
      metadata: {},
      nickname: null,
      product: "prod_OLDHCaYW7Sp4Xg",
      tiers_mode: null,
      transform_usage: null,
      trial_period_days: null,
      usage_type: "licensed",
    },
    quantity: 1,
    schedule: null,
    start_date: 1690474563,
    status: "active",
    test_clock: null,
    transfer_data: null,
    trial_end: null,
    trial_settings: {
      end_behavior: {
        missing_payment_method: "create_invoice",
      },
    },
    trial_start: null,
  },
};

export const updatedAccountExample = {
  id: "test_account",
  name: "Updated Account",
  icon: "stripe",
  payload: {
    id: "acct_1Nk2DXINGsstqbEy",
    object: "account",
    business_profile: {
      mcc: null,
      name: null,
      support_address: null,
      support_email: null,
      support_phone: null,
      support_url: null,
      url: null,
      product_description: null,
    },
    capabilities: {},
    charges_enabled: false,
    controller: {
      type: "application",
      is_controller: true,
    },
    country: "GB",
    default_currency: "gbp",
    details_submitted: false,
    email: null,
    payouts_enabled: false,
    settings: {
      bacs_debit_payments: {},
      branding: {
        icon: null,
        logo: null,
        primary_color: null,
        secondary_color: null,
      },
      card_issuing: {
        tos_acceptance: {
          date: null,
          ip: null,
        },
      },
      card_payments: {
        statement_descriptor_prefix: null,
        statement_descriptor_prefix_kanji: null,
        statement_descriptor_prefix_kana: null,
        decline_on: {
          avs_failure: false,
          cvc_failure: false,
        },
      },
      dashboard: {
        display_name: null,
        timezone: "Etc/UTC",
      },
      payments: {
        statement_descriptor: null,
        statement_descriptor_kana: null,
        statement_descriptor_kanji: null,
      },
      sepa_debit_payments: {},
      payouts: {
        debit_negative_balances: true,
        schedule: {
          delay_days: 7,
          interval: "daily",
        },
        statement_descriptor: null,
      },
    },
    type: "standard",
    business_type: null,
    created: 1693216724,
    external_accounts: {
      object: "list",
      data: [],
      has_more: false,
      total_count: 0,
      url: "/v1/accounts/acct_1Nk2DXINGsstqbEy/external_accounts",
    },
    future_requirements: {
      alternatives: [],
      current_deadline: null,
      currently_due: [],
      disabled_reason: null,
      errors: [],
      eventually_due: [],
      past_due: [],
      pending_verification: [],
    },
    metadata: {
      foo: "bar",
    },
    requirements: {
      alternatives: [],
      current_deadline: null,
      currently_due: [
        "business_profile.product_description",
        "business_profile.support_phone",
        "business_profile.url",
        "external_account",
        "tos_acceptance.date",
        "tos_acceptance.ip",
      ],
      disabled_reason: "requirements.past_due",
      errors: [],
      eventually_due: [
        "business_profile.product_description",
        "business_profile.support_phone",
        "business_profile.url",
        "external_account",
        "tos_acceptance.date",
        "tos_acceptance.ip",
      ],
      past_due: ["external_account", "tos_acceptance.date", "tos_acceptance.ip"],
      pending_verification: [],
    },
    tos_acceptance: {
      date: null,
      ip: null,
      user_agent: null,
    },
  },
};

export const createdCustomerExample = {
  id: "created_customer",
  name: "Created Customer",
  icon: "stripe",
  payload: {
    id: "cus_OX6SuD19Ej1AwM",
    object: "customer",
    address: null,
    balance: 0,
    created: 1693216865,
    currency: null,
    default_source: null,
    delinquent: false,
    description: "(created by Stripe CLI)",
    discount: null,
    email: null,
    invoice_prefix: "02F47541",
    invoice_settings: {
      custom_fields: null,
      default_payment_method: null,
      footer: null,
      rendering_options: null,
    },
    livemode: false,
    metadata: {},
    name: null,
    phone: null,
    preferred_locales: [],
    shipping: null,
    tax_exempt: "none",
    test_clock: null,
  },
};

export const deletedCustomerExample = {
  id: "deleted_customer",
  name: "Deleted Customer",
  icon: "stripe",
  payload: {
    id: "cus_OX6UWArTxl2eGx",
    object: "customer",
    address: null,
    balance: 0,
    created: 1693216947,
    currency: null,
    default_source: null,
    delinquent: false,
    description: "(created by Stripe CLI)",
    discount: null,
    email: null,
    invoice_prefix: "2761E4C9",
    invoice_settings: {
      custom_fields: null,
      default_payment_method: null,
      footer: null,
      rendering_options: null,
    },
    livemode: false,
    metadata: {},
    name: null,
    phone: null,
    preferred_locales: [],
    shipping: null,
    tax_exempt: "none",
    test_clock: null,
  },
};

export const capturedChargeExample = {
  id: "charge.captured",
  name: "charge.captured",
  icon: "stripe",
  payload: {
    id: "ch_3Nk2IZI0XSgju2ur1KjXKcEP",
    object: "charge",
    amount: 2000,
    amount_captured: 2000,
    amount_refunded: 0,
    application: null,
    application_fee: null,
    application_fee_amount: null,
    balance_transaction: "txn_3Nk2IZI0XSgju2ur1yBd2FPs",
    billing_details: {
      address: {
        city: null,
        country: null,
        line1: null,
        line2: null,
        postal_code: null,
        state: null,
      },
      email: null,
      name: null,
      phone: null,
    },
    calculated_statement_descriptor: "WWW.TRIGGER.DEV",
    captured: true,
    created: 1693217035,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    destination: null,
    dispute: null,
    disputed: false,
    failure_balance_transaction: null,
    failure_code: null,
    failure_message: null,
    fraud_details: {},
    invoice: null,
    livemode: false,
    metadata: {},
    on_behalf_of: null,
    order: null,
    outcome: {
      network_status: "approved_by_network",
      reason: null,
      risk_level: "normal",
      risk_score: 23,
      seller_message: "Payment complete.",
      type: "authorized",
    },
    paid: true,
    payment_intent: "pi_3Nk2IZI0XSgju2ur1c5PRXzB",
    payment_method: "pm_1Nk2IZI0XSgju2urQoHr945x",
    payment_method_details: {
      card: {
        brand: "visa",
        checks: {
          address_line1_check: null,
          address_postal_code_check: null,
          cvc_check: null,
        },
        country: "US",
        exp_month: 8,
        exp_year: 2024,
        fingerprint: "w6qgKDLO5EbIJ5VZ",
        funding: "credit",
        installments: null,
        last4: "4242",
        mandate: null,
        network: "visa",
        network_token: {
          used: false,
        },
        three_d_secure: null,
        wallet: null,
      },
      type: "card",
    },
    receipt_email: null,
    receipt_number: null,
    receipt_url:
      "https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xTVJtRzRJMFhTZ2p1MnVyKI3isacGMgaiHlW3-3o6LBbtHkEOlE2XK3_d2h9msrs3bTJvZi8DcqHrvcQrwxPHm8rP3LA2i5wTqA7Y",
    refunded: false,
    review: null,
    shipping: null,
    source: null,
    source_transfer: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "succeeded",
    transfer_data: null,
    transfer_group: null,
  },
};

export const succeededChargeExample = {
  id: "charge.succeeded",
  name: "charge.succeeded",
  icon: "stripe",
  payload: {
    id: "ch_3Nk2MlI0XSgju2ur0Zcv519e",
    object: "charge",
    amount: 2000,
    amount_captured: 0,
    amount_refunded: 0,
    application: null,
    application_fee: null,
    application_fee_amount: null,
    balance_transaction: null,
    billing_details: {
      address: {
        city: null,
        country: null,
        line1: null,
        line2: null,
        postal_code: null,
        state: null,
      },
      email: null,
      name: null,
      phone: null,
    },
    calculated_statement_descriptor: "WWW.TRIGGER.DEV",
    captured: false,
    created: 1693217296,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    destination: null,
    dispute: null,
    disputed: false,
    failure_balance_transaction: null,
    failure_code: null,
    failure_message: null,
    fraud_details: {},
    invoice: null,
    livemode: false,
    metadata: {},
    on_behalf_of: null,
    order: null,
    outcome: {
      network_status: "approved_by_network",
      reason: null,
      risk_level: "normal",
      risk_score: 3,
      seller_message: "Payment complete.",
      type: "authorized",
    },
    paid: true,
    payment_intent: "pi_3Nk2MlI0XSgju2ur0p8h6qIg",
    payment_method: "pm_1Nk2MlI0XSgju2urdy1jOUTb",
    payment_method_details: {
      card: {
        brand: "visa",
        checks: {
          address_line1_check: null,
          address_postal_code_check: null,
          cvc_check: null,
        },
        country: "US",
        exp_month: 8,
        exp_year: 2024,
        fingerprint: "w6qgKDLO5EbIJ5VZ",
        funding: "credit",
        installments: null,
        last4: "4242",
        mandate: null,
        network: "visa",
        network_token: {
          used: false,
        },
        three_d_secure: null,
        wallet: null,
      },
      type: "card",
    },
    receipt_email: null,
    receipt_number: null,
    receipt_url:
      "https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xTVJtRzRJMFhTZ2p1MnVyKJDksacGMgYAj-PAr_s6LBapIJAZx3QBJGs7up7CDkowPkzJbOD1CzDvmilNbsloUF9ovZ3sWPq6F5SN",
    refunded: false,
    review: null,
    shipping: null,
    source: null,
    source_transfer: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "succeeded",
    transfer_data: null,
    transfer_group: null,
  },
};

export const failedChargeExample = {
  id: "charge.failed",
  name: "charge.failed",
  icon: "stripe",
  payload: {
    id: "ch_3Nk2OVI0XSgju2ur09WGXz58",
    object: "charge",
    amount: 100,
    amount_captured: 0,
    amount_refunded: 0,
    application: null,
    application_fee: null,
    application_fee_amount: null,
    balance_transaction: null,
    billing_details: {
      address: {
        city: null,
        country: null,
        line1: null,
        line2: null,
        postal_code: null,
        state: null,
      },
      email: null,
      name: null,
      phone: null,
    },
    calculated_statement_descriptor: "WWW.TRIGGER.DEV",
    captured: false,
    created: 1693217403,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    destination: null,
    dispute: null,
    disputed: false,
    failure_balance_transaction: null,
    failure_code: "card_declined",
    failure_message: "Your card was declined.",
    fraud_details: {},
    invoice: null,
    livemode: false,
    metadata: {},
    on_behalf_of: null,
    order: null,
    outcome: {
      network_status: "declined_by_network",
      reason: "generic_decline",
      risk_level: "normal",
      risk_score: 10,
      seller_message: "The bank did not return any further details with this decline.",
      type: "issuer_declined",
    },
    paid: false,
    payment_intent: "pi_3Nk2OVI0XSgju2ur0HYvM3Zu",
    payment_method: "pm_1Nk2OVI0XSgju2uri9io5fc0",
    payment_method_details: {
      card: {
        brand: "visa",
        checks: {
          address_line1_check: null,
          address_postal_code_check: null,
          cvc_check: null,
        },
        country: "US",
        exp_month: 8,
        exp_year: 2024,
        fingerprint: "LvNwBVtV2ETBNH8a",
        funding: "credit",
        installments: null,
        last4: "0002",
        mandate: null,
        network: "visa",
        network_token: {
          used: false,
        },
        three_d_secure: null,
        wallet: null,
      },
      type: "card",
    },
    receipt_email: null,
    receipt_number: null,
    receipt_url: null,
    refunded: false,
    review: null,
    shipping: null,
    source: null,
    source_transfer: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "failed",
    transfer_data: null,
    transfer_group: null,
  },
};

export const refundedChargeExample = {
  id: "charge.refunded",
  name: "charge.refunded",
  icon: "stripe",
  payload: {
    id: "ch_3Nk2PLI0XSgju2ur1DqK0bOn",
    object: "charge",
    amount: 100,
    amount_captured: 100,
    amount_refunded: 100,
    application: null,
    application_fee: null,
    application_fee_amount: null,
    balance_transaction: "txn_3Nk2PLI0XSgju2ur18SfGzBU",
    billing_details: {
      address: {
        city: null,
        country: null,
        line1: null,
        line2: null,
        postal_code: null,
        state: null,
      },
      email: null,
      name: null,
      phone: null,
    },
    calculated_statement_descriptor: "WWW.TRIGGER.DEV",
    captured: true,
    created: 1693217456,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    destination: null,
    dispute: null,
    disputed: false,
    failure_balance_transaction: null,
    failure_code: null,
    failure_message: null,
    fraud_details: {},
    invoice: null,
    livemode: false,
    metadata: {},
    on_behalf_of: null,
    order: null,
    outcome: {
      network_status: "approved_by_network",
      reason: null,
      risk_level: "normal",
      risk_score: 50,
      seller_message: "Payment complete.",
      type: "authorized",
    },
    paid: true,
    payment_intent: "pi_3Nk2PLI0XSgju2ur1yLml2Ev",
    payment_method: "pm_1Nk2PLI0XSgju2urkxIUAHNK",
    payment_method_details: {
      card: {
        brand: "visa",
        checks: {
          address_line1_check: null,
          address_postal_code_check: null,
          cvc_check: null,
        },
        country: "US",
        exp_month: 8,
        exp_year: 2024,
        fingerprint: "w6qgKDLO5EbIJ5VZ",
        funding: "credit",
        installments: null,
        last4: "4242",
        mandate: null,
        network: "visa",
        network_token: {
          used: false,
        },
        three_d_secure: null,
        wallet: null,
      },
      type: "card",
    },
    receipt_email: null,
    receipt_number: null,
    receipt_url:
      "https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xTVJtRzRJMFhTZ2p1MnVyKLLlsacGMgbTw8sUtqQ6LBZlhILTcNiKqiXYypfyG6CAcLzUmgE7d6GU9FnnRWNQy6-jhF7lW9GCj7qY",
    refunded: true,
    review: null,
    shipping: null,
    source: null,
    source_transfer: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "succeeded",
    transfer_data: null,
    transfer_group: null,
  },
};

export const createdPaymentIntentExample = {
  id: "payment_intent.created",
  name: "payment_intent.created",
  icon: "stripe",
  payload: {
    id: "pi_3Nk2yoI0XSgju2ur14qyhbN6",
    object: "payment_intent",
    amount: 2000,
    amount_capturable: 0,
    amount_details: {
      tip: {},
    },
    amount_received: 0,
    application: null,
    application_fee_amount: null,
    automatic_payment_methods: null,
    canceled_at: null,
    cancellation_reason: null,
    capture_method: "automatic",
    client_secret: "pi_3Nk2yoI0XSgju2ur14qyhbN6_secret_gBSFGokLjHKfG8f5FeVYggBls",
    confirmation_method: "automatic",
    created: 1693219654,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    invoice: null,
    last_payment_error: null,
    latest_charge: null,
    livemode: false,
    metadata: {},
    next_action: null,
    on_behalf_of: null,
    payment_method: null,
    payment_method_options: {
      card: {
        installments: null,
        mandate_options: null,
        network: null,
        request_three_d_secure: "automatic",
      },
    },
    payment_method_types: ["card"],
    processing: null,
    receipt_email: null,
    review: null,
    setup_future_usage: null,
    shipping: null,
    source: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "requires_payment_method",
    transfer_data: null,
    transfer_group: null,
  },
};

export const succeededPaymentIntentExample = {
  id: "payment_intent.succeeded",
  name: "payment_intent.succeeded",
  icon: "stripe",
  payload: {
    id: "pi_3Nk30FI0XSgju2ur1OohIT9i",
    object: "payment_intent",
    amount: 2000,
    amount_capturable: 0,
    amount_details: {
      tip: {},
    },
    amount_received: 2000,
    application: null,
    application_fee_amount: null,
    automatic_payment_methods: null,
    canceled_at: null,
    cancellation_reason: null,
    capture_method: "automatic",
    client_secret: "pi_3Nk30FI0XSgju2ur1OohIT9i_secret_VPcrQS7qSyPZ4GL7BfQRA1X2y",
    confirmation_method: "automatic",
    created: 1693219743,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    invoice: null,
    last_payment_error: null,
    latest_charge: "ch_3Nk30FI0XSgju2ur150Nf8Jf",
    livemode: false,
    metadata: {},
    next_action: null,
    on_behalf_of: null,
    payment_method: "pm_1Nk30FI0XSgju2urEXQYKJsw",
    payment_method_options: {
      card: {
        installments: null,
        mandate_options: null,
        network: null,
        request_three_d_secure: "automatic",
      },
    },
    payment_method_types: ["card"],
    processing: null,
    receipt_email: null,
    review: null,
    setup_future_usage: null,
    shipping: {
      address: {
        city: "San Francisco",
        country: "US",
        line1: "510 Townsend St",
        line2: null,
        postal_code: "94103",
        state: "CA",
      },
      carrier: null,
      name: "Jenny Rosen",
      phone: null,
      tracking_number: null,
    },
    source: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "succeeded",
    transfer_data: null,
    transfer_group: null,
  },
};

export const cancelledPaymentIntentExample = {
  id: "payment_intent.canceled",
  name: "payment_intent.canceled",
  icon: "stripe",
  payload: {
    id: "pi_3Nk316I0XSgju2ur0WYHIexr",
    object: "payment_intent",
    amount: 2000,
    amount_capturable: 0,
    amount_details: {
      tip: {},
    },
    amount_received: 0,
    application: null,
    application_fee_amount: null,
    automatic_payment_methods: null,
    canceled_at: 1693219796,
    cancellation_reason: "requested_by_customer",
    capture_method: "automatic",
    client_secret: "pi_3Nk316I0XSgju2ur0WYHIexr_secret_NWXEzMmLe3IXZIW0HahXUXo9w",
    confirmation_method: "automatic",
    created: 1693219796,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    invoice: null,
    last_payment_error: null,
    latest_charge: null,
    livemode: false,
    metadata: {},
    next_action: null,
    on_behalf_of: null,
    payment_method: null,
    payment_method_options: {
      card: {
        installments: null,
        mandate_options: null,
        network: null,
        request_three_d_secure: "automatic",
      },
    },
    payment_method_types: ["card"],
    processing: null,
    receipt_email: null,
    review: null,
    setup_future_usage: null,
    shipping: null,
    source: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "canceled",
    transfer_data: null,
    transfer_group: null,
  },
};

export const amountCapturablePaymentIntentExample = {
  id: "payment_intent.amount_capturable_updated",
  name: "payment_intent.amount_capturable_updated",
  icon: "stripe",
  payload: {
    id: "pi_3Nk32UI0XSgju2ur0mIrhcYD",
    object: "payment_intent",
    amount: 2000,
    amount_capturable: 2000,
    amount_details: {
      tip: {},
    },
    amount_received: 0,
    application: null,
    application_fee_amount: null,
    automatic_payment_methods: null,
    canceled_at: null,
    cancellation_reason: null,
    capture_method: "manual",
    client_secret: "pi_3Nk32UI0XSgju2ur0mIrhcYD_secret_JyfSHNompZV9sipG3wBgfWf1s",
    confirmation_method: "manual",
    created: 1693219882,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    invoice: null,
    last_payment_error: null,
    latest_charge: "ch_3Nk32UI0XSgju2ur0k1SMSZ4",
    livemode: false,
    metadata: {},
    next_action: null,
    on_behalf_of: null,
    payment_method: "pm_1Nk32UI0XSgju2uriPepd9pr",
    payment_method_options: {
      card: {
        installments: null,
        mandate_options: null,
        network: null,
        request_three_d_secure: "automatic",
      },
    },
    payment_method_types: ["card"],
    processing: null,
    receipt_email: null,
    review: null,
    setup_future_usage: null,
    shipping: null,
    source: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "requires_capture",
    transfer_data: null,
    transfer_group: null,
  },
};

export const failedPaymentIntentExample = {
  id: "payment_intent.payment_failed",
  name: "payment_intent.payment_failed",
  icon: "stripe",
  payload: {
    id: "pi_3Nk341I0XSgju2ur1ckiktWk",
    object: "payment_intent",
    amount: 2000,
    amount_capturable: 0,
    amount_details: {
      tip: {},
    },
    amount_received: 0,
    application: null,
    application_fee_amount: null,
    automatic_payment_methods: null,
    canceled_at: null,
    cancellation_reason: null,
    capture_method: "automatic",
    client_secret: "pi_3Nk341I0XSgju2ur1ckiktWk_secret_3Km19PEIXajFEZRi9qi2VU2d3",
    confirmation_method: "automatic",
    created: 1693219977,
    currency: "usd",
    customer: null,
    description: "(created by Stripe CLI)",
    invoice: null,
    last_payment_error: {
      charge: "ch_3Nk341I0XSgju2ur1UZC5yvb",
      code: "card_declined",
      decline_code: "generic_decline",
      doc_url: "https://stripe.com/docs/error-codes/card-declined",
      message: "Your card was declined.",
      payment_method: {
        id: "pm_1Nk341I0XSgju2uraNBls6mm",
        object: "payment_method",
        billing_details: {
          address: {
            city: null,
            country: null,
            line1: null,
            line2: null,
            postal_code: null,
            state: null,
          },
          email: null,
          name: null,
          phone: null,
        },
        card: {
          brand: "visa",
          checks: {
            address_line1_check: null,
            address_postal_code_check: null,
            cvc_check: null,
          },
          country: "US",
          exp_month: 8,
          exp_year: 2024,
          fingerprint: "LvNwBVtV2ETBNH8a",
          funding: "credit",
          generated_from: null,
          last4: "0002",
          networks: {
            available: ["visa"],
            preferred: null,
          },
          three_d_secure_usage: {
            supported: true,
          },
          wallet: null,
        },
        created: 1693219977,
        customer: null,
        livemode: false,
        metadata: {},
        type: "card",
      },
      type: "card_error",
    },
    latest_charge: "ch_3Nk341I0XSgju2ur1UZC5yvb",
    livemode: false,
    metadata: {},
    next_action: null,
    on_behalf_of: null,
    payment_method: null,
    payment_method_options: {
      card: {
        installments: null,
        mandate_options: null,
        network: null,
        request_three_d_secure: "automatic",
      },
    },
    payment_method_types: ["card"],
    processing: null,
    receipt_email: null,
    review: null,
    setup_future_usage: null,
    shipping: null,
    source: null,
    statement_descriptor: null,
    statement_descriptor_suffix: null,
    status: "requires_payment_method",
    transfer_data: null,
    transfer_group: null,
  },
};
